<template>
  <UlDialog
    v-model="dialog"
    :title="$t('errorModal.title')"
    left-header-icon="icons/person-sad.svg"
    header-type="information"
  >
    <template #text>
      <div class="pb-6" v-html="$t('errorModal.subtitle')" />
      <div v-if="!isPutinSucks">
        <div class="mb-1">{{ $t('authorization.contactTitle') }}</div>
        <template v-if="isUlHc">
          <span v-html="createPhoneLink({ phone: $t('aeskulab.phone') })" /> |
          <span v-html="$t('ulekareContacts.hours')" /> |
          <a :href="'mailto:' + $t('aeskulab.email')">{{ $t('aeskulab.email') }}</a>
        </template>
        <template v-else>
          <span v-html="createPhoneLink()" /> | <span v-html="$t('ulekareContacts.hours')" /> |
          <a :href="'mailto:' + $t('ulekareContacts.email')">{{ $t('ulekareContacts.email') }}</a>
        </template>
        <div class="error-reference">
          {{ $t('errorModal.errorCodeReference') }}
          <span class="font-weight-bold">
            {{ errorCode }}
          </span>
        </div>
      </div>
    </template>
  </UlDialog>
</template>

<script>
import phoneLink from '@/mixins/phoneLink';
export default {
  name: 'ErrorModal',
  mixins: [phoneLink],
  computed: {
    dialog: {
      get() {
        return this.$store.state.profile.dashboard.dialog === 'error';
      },
      set(value) {
        this.$store.commit('profile/dashboard/setDialog', value);

        if (value) {
          this.gtmPush({
            event: 'error',
            'error.type': this.$t('errorModal.title', 'cs'),
            'error.page': this.$route.fullPath
          });
        }
      }
    },
    errorCode() {
      return this.$store.state.errorModal.code;
    }
  }
};
</script>

<style lang="scss" scoped>
.error-reference {
  font-size: 10px;
}
</style>
